import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LocaleService } from '@upr-web-primer/locale';
import { NotificationService } from '@upr-web-primer/notification';
import { CommonUtilityService } from '../../services/common-utility.service';
@Component({
  selector: 'app-lost-found-confirm',
  templateUrl: './lost-found-confirm.component.html',
  styleUrls: ['./lost-found-confirm.component.scss'],
  standalone: false,
})
export class LostFoundConfirmComponent implements OnInit {
  pageLabels: any;
  @Output() backbtn = new EventEmitter<any>();
  disableSendBtn = false;
  lostPropertyRadioButtons: { label: any; value: number }[];
  lostFoundAPIResponse: any;
  lostFoundForm: FormGroup;
  isFormSubmitted: boolean;
  isSubmitting = false;
  constructor(
    private readonly common: CommonUtilityService,
    public notification: NotificationService,
    @Inject('GlobalDefaults') public globalDefault: any,
    private readonly locale: LocaleService,
    private readonly datePipe: DatePipe,
    @Inject('AppRoutes') private readonly appRoutes: any,
  ) {}

  /**
   * ngOnInit - It will load all the functions
   */
  ngOnInit(): void {
    this.common.setConfirmPage(true);
    this.lostFoundForm = this.common.getFormData();
    this.pageLabels = this.common.getResolvedPageData();
    this.common.scrollTop();

    this.lostPropertyRadioButtons = [
      {
        label: this.pageLabels?.['lostForm.property_found_park'],
        value: 752510000,
      },
      {
        label: this.pageLabels?.['lostForm.property_found_mail'],
        value: 752510001,
      },
    ];
  }

  /**
   * lostFoundBackBtn - Pass stored data from confirmation page to creation page when user clicks on bak CTA
   */
  lostFoundBackBtn(): any {
    this.backbtn.emit({
      lostFoundForm: this.lostFoundForm,
    });
    this.common.setFormData(this.lostFoundForm);
    this.common.changeRoute(this.appRoutes.LOST_FOUND);
  }

  /**
   * getSelectedLostPropertyLabel - get the label based on selected value
   * @param value - pass the selected value from  inquiry dropdown
   * @returns
   */
  getSelectedLostPropertyLabel(value: number): string {
    const matchedItem = this.lostPropertyRadioButtons.find(
      (item) => item.value === value,
    );
    return matchedItem ? matchedItem.label : '';
  }

  /**
   * onSubmitLostFoundCreation - It will submit the formControl to api url
   */
  onSubmitLostFoundCreation(): any {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    const data = this.lostFoundForm.value;
    const request: any = {
      udx_emailaddress: data?.email,
      udx_furiganafirstname: data?.first_name_furgina,
      udx_firstname: data?.firstName,
      udx_surname: data?.lastName,
      udx_furiganasurname: data?.last_name_furgina,
      udx_registrationconfirmation: data?.agree,
      udx_firsttimeregistration: data?.countAgree,
      udx_privacypolicy: data?.privacyAgree,
      udx_postalcode: data?.postalCode,
      udx_prefecture: data?.prefecture,
      udx_city: data?.city,
      udx_townvillage: data?.town,
      udx_streetblocknumberhouse: data?.street,
      udx_dateofloss: data?.dob,
      udx_losttime: data?.lostTime,
      udx_lostlocation: data?.lostLocation,
      udx_lostitem: 752510000,
      udx_detailsoflostitem: this.lostFoundForm
        .get('detailLostItem')
        ?.value.trim(),
      udx_returnmethod: data?.selectedLostPropertyButton,
      udx_phonenumber: data?.phoneNumber,
      'udx_category_udx_lostandfound@odata.bind': `udx_maincategories(${data?.mainCategoryId})`,
    };
    this.common
      .lostFoundWebForm(request, this.globalDefault?.LOST_AND_FOUND)
      .subscribe(
        (res: any) => {
          this.disableSendBtn = true;
          this.isFormSubmitted = true;
          this.common.setFormSubmitted(this.isFormSubmitted);
          this.lostFoundAPIResponse = res;
          this.lostFoundOptions(this.lostFoundAPIResponse);
        },
        () => {
          this.notification.show(this.pageLabels?.['errCode.E019']);
          this.isSubmitting = false;
        },
      );
  }

  /**
   * lostFoundOptions - Call and pass the selected option ID and option to the API
   * @param response
   */
  lostFoundOptions(response: any): any {
    const subcategories = this.lostFoundForm?.value?.subcategories;

    subcategories?.forEach((subCategory: any) => {
      const selectedOption = subCategory?.selectedOption;
      const selectedOptionId = subCategory?.selectedOptionId;

      if (selectedOption && selectedOptionId) {
        const request = {
          'udx_lostfound@odata.bind': `udx_lostandfounds(${response?.body?.activityid})`,
          'udx_option@odata.bind': `udx_options(${selectedOptionId})`,
          udx_name: `${subCategory?.subCategoryName} - ${selectedOption}`,
        };

        // Call the service to submit the request
        this.common
          .lostFoundWebFormOptions(request, this.globalDefault?.LOST_AND_FOUND)
          .subscribe(
            (res: any) => {
              if (res) {
                this.notification.show(
                  this.pageLabels?.['lostForm.success'],
                  this.globalDefault.SUCCESS,
                );
              }
            },
            (err: any) => {
              if (err) {
                // Error notification if any API call fails
                this.notification.show(this.pageLabels?.['errCode.E019']);
              }
            },
          );
      }
    });
  }

  /**
   * formatShortDate - display the date format based on the languages
   * @param date - pass the selected date from user
   * @returns
   */
  formatShortDate(date: Date): string {
    const localeInfo = this.locale.getFromUrl();
    if (localeInfo?.language === 'en') {
      return this.datePipe?.transform(date, 'MMM dd, yyyy') || '';
    } else {
      return this.datePipe?.transform(date, 'yyyy年MM月dd日') || '';
    }
  }
}
